// Hex fallbacks for chart components running in non-browser contexts
// (jsdom tests, SSR). Real browsers always have the matching CSS
// variables from tokens.css resolved, so readCssVar() returns those.
// These constants live in tokens/ because the eslint no-raw-tokens
// rule legitimately allows raw hex inside tokens/ — the file is the
// canonical place to spell out what each design token resolves to.
//
// Keep in sync with tokens.json + tokens.css.

export const ChartColorFallback = {
  critical: '#A32D2D',
  warn: '#B36B1F',
  watch: '#A88A29',
  healthy: '#3F7C3F',
  info: '#1F4E79',
  infoBg: '#E7EEF6',
  gray300: '#DEE5EE',
  gray700: '#5F5E5A',
} as const;
